import * as Yup from 'yup';
import {
    MAX_TERM_NAME_LENGTH,
    NAME_REGEXP,
    LONG_TEXT_REGEXP,
    LONG_TEXT_DEFINITION,
    CustomPropertyDefinitionTypes,
    CustomPropertyTargets
} from 'app/lib/constants';

const getPropertyNameSchema = () =>
    Yup.string()
        .trim('admin:GlossaryManagement.ConfigureGlossaryTermDialog.errors.whitespace')
        .matches(NAME_REGEXP, {
            message: 'customProperties:Configure.name.charsWarning'
        })
        .max(MAX_TERM_NAME_LENGTH, 'customProperties:Configure.name.lengthWarning');

export const getPropertySchema = () =>
    Yup.object({
        target: Yup.string()
            .oneOf(Object.values(CustomPropertyTargets))
            .required('customProperties:Configure.target.requiredWarning'),
        type: Yup.string().oneOf(CustomPropertyDefinitionTypes).required(),
        name: getPropertyNameSchema().required('customProperties:Configure.name.requiredWarning'),
        defaultValue: Yup.string().when('type', {
            is: (type) => type !== LONG_TEXT_DEFINITION,
            then: (schema) =>
                schema
                    .nullable()
                    .trim('admin:GlossaryManagement.ConfigureGlossaryTermDialog.errors.whitespace')
                    .matches(NAME_REGEXP, {
                        message: 'customProperties:Configure.defaultValue.charsWarning'
                    }),
            otherwise: (schema) =>
                schema.max(400).nullable().matches(LONG_TEXT_REGEXP, {
                    message: 'customProperties:Configure.defaultValue.charsWarningLong'
                })
        }),
        options: Yup.array()
            .of(
                Yup.object().shape({
                    current: Yup.string().trim(
                        'admin:GlossaryManagement.ConfigureGlossaryTermDialog.errors.whitespace'
                    ),
                    previous: Yup.string().trim(
                        'admin:GlossaryManagement.ConfigureGlossaryTermDialog.errors.whitespace'
                    )
                })
            )
            .nullable()
            .min(1)
    });
